import {default as Component} from './UserLogoutControl'
import {logout} from '../../redux/actions'
import {connect} from 'react-redux'

const UserLogoutControl = connect(
	(state) => ({
		visible: state.login.isLoggedIn,
		//username: (state.login.isLoggedIn ? state.login.user['cognito:username'] : 'Not Logged In') //TODO: Move cognito specific items to a different place
	}),
	(dispatch) => ({
		click: () => {
			dispatch(logout())
		}
	})
)(Component)

UserLogoutControl.defaultProps = {
	visible: null,
	//username: '',
	click: null,
}

export default UserLogoutControl


// WEBPACK FOOTER //
// ./src/components/UserLogoutControl/index.js